import styled from '@emotion/styled';

export const ViolationsSummaryWrapper = styled.div`

`;

export const ViolationTableColumn = styled.div`

`;

export const SeverityWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SeverityItem = styled.div<{ isMatched: boolean }>`
  width: 12px;
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.micro};
  &:not(:last-of-type) {
    margin-${({ theme }) => theme.isRTL ? 'left' : 'right'}: 4px;
  }
  ${({ theme, isMatched }) => `
    background-color: ${isMatched ? theme.colors.insights.nuisances : theme.colors.neutrals.grey8};
  `}
`;

